import React, { Component } from 'react';
import { InputSelect } from '../../../commonModules/interface/form-input-inline.jsx';
import Spin from '../../../commonModules/interface/Spin';
import { BreadCrumb } from './containers/Layout';
import SingleShop from './shops/SingleShop.jsx';
import FormReappro from './reapproIntern/FormReappro.jsx';
import ListReappro from './reapproIntern/ListReappro.jsx';
import SingleReappro from './reapproIntern/SingleReappro';
import { isEmpty } from 'lodash';
import { Button, Card, Grid, Box } from '@material-ui/core';
import CardPage from '../../../commonModules/layouts/CardPage.jsx';
import DeleteDialog from '../../../commonModules/interface/DeleteDialog.jsx';
import ShopFilter, { filterShop, filterShopReappro } from './Filter/ShopFilter.jsx';
import DateFilter, { filterDate } from './Filter/DateFilter.jsx';
import { firstDayOfYear, sixMonthsAgo } from '../../../commonModules/utils/statsFunctions.jsx';
import AccordionFilter from './Filter/AccordionFilter.jsx';
import { toast } from 'react-toastify';
import axios from 'axios';
import ListTransferReappro from './transfers/reappro/ListTransferReappro.jsx';
import SingleTransferReappro from './transfers/reappro/SingleTransferReappro.jsx';
import { formatData, sortByDateReverse } from '../../../../../../jsx/actions/utils';

class ReapproInternDraft extends Component{
    state = {
        // Dialog
        showSale:false,
        showNew: this.props.new,

        singleShop:{},
        updateDraft:{},
        singleSale:{
            sale:{},
            shop:{},
            shopDest:{},
        },

        breadcrumb: "",
        
        deletePopUp: false,
        toDelete:{
            id:""
        },
        mdpAdmin:"",
        errors:{
            mdpAdmin:"",
        },

        filteredList: [],
        pageOfItems: [],
        currentPage: 0,
        rowsPerPage: 20,
        reload : false,

        search:"",

        selctShopSRC:{
            value:"",
            label:"Tous les Magasins",
        },
        selectShopDST:{
            value:"",
            label:"Tous les Magasins",
        },
        received: "ALL",
        start_date: sixMonthsAgo,
        // start_date: firstDayOfYear,
        end_date: new Date(),
        REA_DRAFTS: []
    }
    
    // componentDidMount = () => {
    //     console.log("MOUNTING Reappro ");
    //     this.fetchDrafts()
    // }
    fetchDrafts = async () => {
        this.setState({ fetching: true });
        try {
            const res = await axios.post("/stocks/getList", {
                page: "draft"
            });

            console.log('====================================');
            console.log({res});
            console.log('====================================');

            if(res?.data?.error){
                throw new Error(
                    res.data.error?.message ||
                    res.data.error?.error ||
                    "Une erreur est survenue lors de la récupération des brouillons"
                );
            }

            const drafts = Array.isArray(res?.data)
                ? res.data
                : Array.isArray(res?.data?.data)
                    ? res.data.data
                    : Array.isArray(res?.data?.results)
                        ? res.data.results
                        : [];

            if(!Array.isArray(res?.data)){
                console.warn("[WARN] fetchDrafts: unexpected response shape", res?.data);
            }

            const formattedData = formatData(sortByDateReverse(drafts.slice()));
            this.setState({
                REA_DRAFTS: formattedData,
                fetching: false,
                showNew:false,
                updateDraft: {}
            });
        } catch (error) {
            console.log("[ERROR] SUBMIT ", error);
            toast.error(error?.message || "Impossible de récupérer les brouillons");
            this.setState({
                fetching: false,
                showNew:false,
                updateDraft: {}
            });
        }
    }
    onChangePage = (pageOfItems, currentPage, rowsPerPage) => {
        // update state with new page of items
        this.setState({ pageOfItems, currentPage, rowsPerPage });
    }

    shopFilter = (selected) => {
        const { REA_DRAFTS } = this.props
        
        let filteredShop = Object.values(REA_DRAFTS).filter( rea => {
                return (rea.shop_id === selected)
            }
        )
        console.log({filteredShop});
        return filteredShop
    }
    
    getFilteredList = () => {
        // Use local state if available (from fetchDrafts), otherwise fall back to props
        const REA_DRAFTS = this.state.REA_DRAFTS && Object.keys(this.state.REA_DRAFTS).length > 0 
            ? this.state.REA_DRAFTS 
            : this.props.REA_DRAFTS || {};
        const {selectShopSRC, selectShopDEST } = this.state;
        
        let list = filterDate(REA_DRAFTS, this.state.start_date, this.state.end_date, "creation_date")
        list = filterShopReappro(list, selectShopSRC, selectShopDEST)
        
        return list
    }
    // LISTS & TABLES
                   
        deleteReappro = async () => {

            let res = await axios.post("/stocks/delete", {
                type:"reappro/draft",
                data:this.state.toDelete
            }) 
    
                
            console.log('====================================');
            console.log({res});
            console.log('====================================');
            if(!res.data.error){
                toast.success( "Brouillon supprimé avec succès")
                this.setState({
                    deletePopUp:false,
                    toDelete:{id: ""},
                })
                // Refetch the draft list after deletion
                this.fetchDrafts()
            } else {
                console.log("[ERROR] SUBMIT ", res.data.error);
                toast.error(  "Un Problème est survenu")
            }
            // await this.props.deleteReapproDraft(this.state.toDelete)
            
            // if(this.props.STATE.sales.error){
            //     console.log("[ERROR] delete reappro", this.props.STATE.sales.error); 
            //     toast.error(  "Un Problème est survenu")
            // } else {
            //     toast.success( "Brouillon supprimé avec succès")
            //     this.setState({
            //         deletePopUp:false,
            //         toDelete:{id: ""},
            //     })
            // }  
        }
        
        handleSelectMulti = (option, name) => {
            if(option){
                this.setState({                
                    [name]: option,
                    currentPage: 0,
                    currentPageProd: 0,
                })
            } else {
                this.setState({
                    [name]: {label: "", value: ""},
                    currentPage: 0,
                    currentPageProd: 0,
                })
    
            }
        }
        
    // CLEAR & DISPLAY        
        handleCloseDraft = () => {
            this.fetchDrafts()
            // this.setState({
            //     showNew:false,
            //     updateDraft: {}
            // });
        }
        handleClose = () => {
            this.setState({
                showSale:false,
                showNew:false,
                showSingleProd: false,
                showSingleShop: false,
                breadcrumb: "",
                updateDraft: {}
            });
        }

        handleSingleShop = (shop) => {
            this.setState({
                breadcrumb: shop.name,
                singleShop:shop,
                showSingleShop: true
            })

        }
        handleSingleSale = (reappro, shop, shopDest) => {
            this.setState({
                showSale:true,
                singleSale:{sale:reappro, shop, shopDest},
                breadcrumb:`Reappro n°${reappro.id}`
            })

        }
        handleUpdate = (reappro) => {
            this.setState({
                showNew:true,
                updateDraft:reappro,
                breadcrumb:`Reappro n°${reappro.id}`
            })

        }
        handleDelete = (reappro) => {
            this.setState({
                toDelete: reappro,
                deletePopUp : true,
            })
        }


    render(){
        console.log("[STATE] ",this.state);
        const {showSale, showSingleShop, showSingleProd, showNew, breadcrumb, deletePopUp, toDelete } = this.state;
        // let shops = this.createShopList()
        
        return(
            <CardPage 
                title="Brouillons Reapprovisionnement"
                storehouse
                action={!showSale && !showSingleShop && !showSingleProd && !showNew &&
                    <Box>
                        <Button 
                            color="primary" 
                            variant="contained"
                            onClick={ () => this.setState({showNew: true, breadcrumb:"Nouveau"}) }
                        > Nouveau
                        </Button>
                    </Box>
                }
            >
                <BreadCrumb breadcrumb={ breadcrumb } title="Reapprovisionnements" back={this.handleClose} />
                {deletePopUp && toDelete.id &&
                    <DeleteDialog
                        title={"le brouillon n°"+toDelete.id}
                        handleSubmit={this.deleteReappro}
                        close={()=>this.setState({deletePopUp: false})}
                        open={true}
                        disabled={this.props.STATE.sales.fetching}
                        noPassword
                    />
                }
                
                {showSingleShop &&                        
                    <SingleShop shop={this.state.singleShop} {...this.props} />
                }       
                
                {showNew &&
                    <FormReappro
                        {...this.props}
                        handleClose={this.handleCloseDraft}
                        oldRea={this.state.updateDraft}
                        draft
                        // filterList={this.filterList}
                    />
                }
                {showSale && !showNew &&
                    <SingleTransferReappro
                        transfer={this.state.singleSale.sale} 
                        shop={this.state.singleSale.shop} 
                        shopDest={this.state.singleSale.shopDest} 
                        handleUpdate={this.handleUpdate}
                        {...this.props} 
                        getPhoto={this.props.getPhoto}
                        draft
                    />
                }
            
                {!showSale && !showSingleShop && !showSingleProd && !showNew &&
                <Box>
                    <AccordionFilter>
                        <Grid container >
                            <DateFilter
                                handleChangeDate={(date, name) => this.setState({ [name]: date })}
                                {...this.state}
                            />
                            <Grid item xs={12} sm={6}>
                                <ShopFilter
                                    fieldName="selectShopSRC"
                                    value={this.state.selectShopSRC}
                                    handleSelect={this.handleSelectMulti}
                                />
                            </Grid>
                        </Grid>
                    </AccordionFilter>
                    {this.props.STATE.sales.fetching && <Spin noOverlay/>}

                        <ListTransferReappro 
                            {...this.state}
                            {...this.props}
                            handleSingleShop={this.handleSingleShop}
                            handleSingleSale={this.handleSingleSale}
                            changeStatus={this.changeStatus}
                            handleDelete={this.handleDelete}
                            onChangePage={this.onChangePage}
                            getFilteredList={this.getFilteredList}
                            draft
                        />  
                </Box>
                }
                
            </CardPage>

        )
    }
}



export default ReapproInternDraft